
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppConfigurations"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAppConfigurations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appVersion"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isUpdateRequired"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"whatsappNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adminNotificationEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"whatsappMessage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"freezeMaxDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"freezeMinDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"freezeUpToDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isShopActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isFreezeActive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shoppingView"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultShift"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryCharge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dietitianBookingTypeDescription"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bookingType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"customerReferralPercent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxReferralAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxRedeemPercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxRedeemAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxReferralAmountGive"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percentageGive"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"splashScreenContent"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page_one"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentAr"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"page_two"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentAr"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"page_three"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentAr"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultMealSelectionDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultPackageSelectionDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packageCycleDay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isStoreOn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeOnTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storeOffTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"setmenuPlanTag"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ar"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isPortionEnabled"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1004}};
    doc.loc.source = {"body":"query getAppConfigurations {\n  getAppConfigurations {\n    _id\n    appVersion {\n      currentVersion\n      isUpdateRequired\n    }\n    whatsappNumber\n    adminNotificationEmail\n    whatsappMessage\n    freezeMaxDays\n    freezeMinDays\n    freezeUpToDays\n    isShopActive\n    isFreezeActive\n    shoppingView\n    defaultShift\n    deliveryCharge\n    dietitianBookingTypeDescription {\n      bookingType\n      description\n    }\n    customerReferralPercent {\n      percentage\n      maxReferralAmount\n      maxRedeemPercent\n      maxRedeemAmount\n      maxReferralAmountGive\n      percentageGive\n    }\n    splashScreenContent {\n      page_one {\n        contentEn\n        contentAr\n      }\n      page_two {\n        contentEn\n        contentAr\n      }\n      page_three {\n        contentEn\n        contentAr\n      }\n    }\n    defaultMealSelectionDay\n    defaultPackageSelectionDay\n    packageCycleDay\n    isStoreOn\n    storeOnTime\n    storeOffTime\n    setmenuPlanTag {\n      en\n      ar\n    }\n    isPortionEnabled\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getAppConfigurations"] = oneQuery(doc, "getAppConfigurations");
        
